// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2MxnP","notes":"Notes_notes__1f28y","note":"Notes_note__kYD8P","markdown":"Notes_markdown__1xVe7"};